'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'flask';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f0c3';
var svgPathData = 'M437.2 403.5L319.1 215L319.1 48h7.998c13.25 0 23.1-10.75 23.1-24S341.2 0 327.1 0H120C106.8 0 96.01 10.75 96.01 24S106.8 48 120 48h7.998L128 215l-117.2 188.5C-18.48 450.6 15.27 512 70.89 512h306.2C432.7 512 466.5 450.5 437.2 403.5zM119.2 320l56.78-91.29V48h95.98v180.7L328.8 320H119.2z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFlask = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;